import React, { useState, useRef, useEffect } from "react";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { setTheme } from "../../Reducers/General";
import { useDispatch } from "react-redux";
import { useInput } from "react-admin";
import { InputButton } from './styles';
function ImageUpload(props) {
  const { onCropImage } = props;
  const {
    input: { name, onChange },
    meta: { touched, error },
    isRequired,
  } = useInput(props);

  const dispatch = useDispatch();

  //    const { crop, croppedImageUrl, src } = this.state;
  const [src, setSrc] = useState(null);
  const [crop, setCrop] = useState({
    height: 100,
    unit: "%",
    width: 100,
    x: 0,
    y: 0,
  });
  const imageRef = useRef(null);
  const inputRef = useRef(null);

  const [croppedImageUrl, setCroppedImageUrl] = useState(null);

  const onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setSrc(reader.result));
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const onImageLoaded = (image) => {
    imageRef.current = image;
  };

  const onCropComplete = () => {
    makeClientCrop(crop);
  };

  const onCropChange = (crop, percentCrop) => {
    // You could also use percentCrop:
    // this.setState({ crop: percentCrop });

    setCrop({ ...percentCrop });
  };

  const makeClientCrop = async (crop) => {
    if (imageRef.current && crop.width && crop.height) {
      const croppedImageUrl = await getCroppedImg(
        imageRef.current,
        crop,
        "newFile.jpeg"
      );
      setCroppedImageUrl(croppedImageUrl);

      dispatch(
        setTheme({
          cover: croppedImageUrl,
        })
      );
      onChange(croppedImageUrl);
      //console.log("crop info", imageRef);
      onCropImage(croppedImageUrl);
    }
  };

  const getCroppedImg = (image, crop, fileName) => {
    //console.log("getCroppedImg", image, crop);
    const canvas = document.createElement("canvas");
    const scaleX = image.naturalWidth / 100;
    const scaleY = image.naturalHeight / 100;
    canvas.width = scaleX * crop.width;
    canvas.height = scaleY * crop.height;
    const ctx = canvas.getContext("2d");

    //console.log("scaleX", image.naturalWidth / 100);
    //console.log("crop.x", crop.x * scaleX);
    //console.log("crop.y", crop.y * scaleY);

    //console.log("crop.width", crop.width * scaleY);
    //console.log("crop.height", crop.height * scaleY);
    ctx.fillStyle = "white";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width * scaleX,
      crop.height * scaleY
    );

    return new Promise((resolve, reject) => {
      canvas.toBlob((blob) => {
        if (!blob) {
          //reject(new Error('Canvas is empty'));
          console.error("Canvas is empty");
          return;
        }
        blob.name = fileName;
        let fileUrl = null;
        window.URL.revokeObjectURL(fileUrl);
        fileUrl = window.URL.createObjectURL(blob);
        //console.log("fileUrl", fileUrl);
        resolve(fileUrl);
      }, "image/jpeg");
    });
  };
  return (
    <>
      <div>
        <input
          ref={inputRef}
          type="file"
          style={{visibility:'hidden'}}
          name={name}
          accept="image/*"
          onChange={onSelectFile}
        />
        <InputButton onClick={()=>{inputRef.current.click()}}><span>Clique aqui para alterar sua imagem de capa</span></InputButton>
      </div>
      {src && (
        <ReactCrop
          src={src}
          crop={crop}
          ruleOfThirds
          onImageLoaded={onImageLoaded}
          onComplete={onCropComplete}
          onChange={onCropChange}
        />
      )}
    </>
  );
}

export default ImageUpload;
